module.exports = __webpack_public_path__ + "static/media/whatsapp-2.d3f13ae1.png";